
/**
 * do not need review have not yet been integrated
 */
import {
  FileText,
  LayoutGrid,
  User,
  Presentation,
  FileBarChart,
  Swords,
  Rocket,
  Map,
  DollarSign,
} from 'lucide-react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog'
import type { ArtifactType } from '@/types/api'

interface ArtifactOption {
  type: ArtifactType
  label: string
  description: string
  icon: React.ElementType
}

const ARTIFACT_OPTIONS: ArtifactOption[] = [
  { type: 'business_model_canvas', label: 'Business Model Canvas', description: 'Full 9-block BMC', icon: LayoutGrid },
  { type: 'lean_canvas', label: 'Lean Canvas', description: 'Lean startup canvas', icon: FileText },
  { type: 'user_persona', label: 'User Persona', description: 'Target user profile', icon: User },
  { type: 'pitch_deck', label: 'Pitch Deck', description: 'Investor pitch outline', icon: Presentation },
  { type: 'one_pager', label: 'One-Pager', description: 'Executive summary', icon: FileBarChart },
  { type: 'competitor_analysis', label: 'Competitor Analysis', description: 'Competitive landscape', icon: Swords },
  { type: 'go_to_market_strategy', label: 'Go-to-Market', description: 'Launch strategy', icon: Rocket },
  { type: 'product_roadmap', label: 'Product Roadmap', description: 'Feature timeline', icon: Map },
  { type: 'financial_model', label: 'Financial Model', description: 'Revenue projections', icon: DollarSign },
]

interface ArtifactPickerDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSelect: (type: ArtifactType) => void
}

export function ArtifactPickerDialog({ open, onOpenChange, onSelect }: ArtifactPickerDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Generate Artifact</DialogTitle>
          <DialogDescription>
            Choose a document type to generate from your context.
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 pt-2 max-h-[60vh] overflow-y-auto">
          {ARTIFACT_OPTIONS.map((opt) => (
            <button
              key={opt.type}
              onClick={() => onSelect(opt.type)}
              className="flex items-center gap-3 p-3 rounded-xl bg-secondary/40 hover:bg-secondary/70 border border-transparent hover:border-primary/20 transition-all text-left group"
            >
              <div className="h-9 w-9 rounded-lg bg-background/50 flex items-center justify-center text-primary group-hover:bg-primary group-hover:text-white transition-colors shrink-0">
                <opt.icon className="h-4 w-4" />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium text-foreground truncate">
                  {opt.label}
                </p>
                <p className="text-xs text-muted-foreground truncate">
                  {opt.description}
                </p>
              </div>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
